export const work = [
    {
        discription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus quae accusantium vero laborum, consequatur mollitia!",
        image: "assets/img/work/profile.png",
        title: "Make a profile"
    },
    {
        discription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus quae accusantium vero laborum, consequatur mollitia!",
        image: "assets/img/work/cloud-computing.png",
        title: "Download it for Free"
    }, {
        discription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus quae accusantium vero laborum, consequatur mollitia!",
        image: "assets/img/work/enjoy.png",
        title: "Enjoy this App"
    },
]